import { SettingsTranslationType } from "../../features/settings.types";

export const settings: SettingsTranslationType = {
  settings: {
    title: "Configuración",
    aiProvider: {
      label: "Proveedor de IA",
      select: "Seleccionar proveedor",
      description: "Seleccione el proveedor de IA para generar historias",
      updateSuccess: "Proveedor de IA actualizado",
      updateSuccessDesc: "Sus preferencias de proveedor de IA han sido guardadas",
      updateError: "Error de actualización",
      updateErrorDesc: "Error al actualizar el proveedor de IA. Por favor intente de nuevo."
    },
    language: {
      label: "Idioma",
      description: "Seleccione su idioma preferido"
    },
    subscription: {
      title: "Suscripción",
      currentPlan: "Plan actual",
      freeTier: "Gratis",
      basicTier: "Básico",
      premiumTier: "Premium",
      status: "Estado",
      renewalDate: "Fecha de renovación",
      upgradePlan: "Mejorar plan",
      managePlan: "Gestionar plan",
      cancelPlan: "Cancelar plan",
      features: "Características",
      billingCycle: "Ciclo de facturación",
      monthlyLabel: "Mensual",
      yearlyLabel: "Anual",
      priceUnits: {
        month: "mes",
        year: "año"
      },
      tiers: {
        free: {
          name: "Gratis",
          description: "Funciones básicas para comenzar",
          price: "Gratis"
        },
        basic: {
          name: "Básico",
          description: "Funciones avanzadas para escritores hobistas",
          price: {
            monthly: "€9.99/mes",
            yearly: "€99/año"
          }
        },
        premium: {
          name: "Premium",
          description: "Acceso completo para escritores profesionales",
          price: {
            monthly: "€19.99/mes",
            yearly: "€199/año"
          }
        }
      },
      browseCharacters: "Explorar Personajes",
      upgradeToBrowse: "Actualiza para explorar tu colección de personajes",
      upgradeToMakePublic: "Actualiza para hacer públicos los personajes",
      upgradeRequired: "Actualización Requerida",
      upgradeToBrowseDescription: "Actualiza tu cuenta para explorar y reutilizar tu colección de personajes.",
      upgradeToMakePublicDescription: "Actualiza tu cuenta para compartir personajes públicamente con otros usuarios.",
      unlockFeatures: "Desbloquea funciones premium con una suscripción",
      upgradeNow: "Actualizar Ahora",
      unlockAiTitleGeneration: "Desbloquear Generación de Títulos con IA",
      upgradeForCharaterAccess: "Actualiza para acceder a la gestión de personajes",
      upgradeForStatsAccess: "Actualiza para acceder a estadísticas e insignias",
      upgradeForAccess: "Actualiza para acceder a esta función",
      upgradeForAiTitleDescription: "Actualiza al plan Básico para acceder a la generación de títulos con IA y obtener sugerencias creativas basadas en los temas, personajes y escenarios de tu historia.",
      generateTitlesFeature: "Genera títulos únicos instantáneamente",
      aiTitleGenerationPremium: "La Generación de Títulos con IA está disponible en el plan Básico",
      unlockGenre: "Actualiza para desbloquear este género",
      unlockCustomGenres: "Desbloquear Géneros Personalizados",
      upgradeForCustomGenresDescription: "Actualiza al plan Básico para crear géneros personalizados y hacer tus historias más únicas.",
      addCustomGenresFeature: "Añade géneros personalizados ilimitados",
      unlockEnvironment: "Actualiza para desbloquear este entorno",
      upgradeForCustomEnvironments: "Actualiza a TaleCraft Básico para añadir entornos personalizados",
      unlockCustomEnvironments: "Desbloquear Entornos Personalizados",
      upgradeForCustomEnvironmentsDescription: "Actualiza al plan Básico para crear entornos personalizados y hacer tus historias más únicas.",
      addCustomEnvironmentsFeature: "Añade entornos personalizados ilimitados",
      unlockTheme: "Actualiza para desbloquear este tema",
      upgradeForCustomThemes: "Actualiza a TaleCraft Básico para añadir temas personalizados",
      unlockCustomThemes: "Desbloquear Temas Personalizados",
      upgradeForCustomThemesDescription: "Actualiza al plan Básico para crear temas personalizados y hacer tus historias más únicas.",
      addCustomThemesFeature: "Añade temas personalizados ilimitados",
      unlockStoryLength: "Actualiza para desbloquear esta longitud de historia",
      upgradeForPremiumLengths: "Actualiza a TaleCraft Básico para acceder a historias más largas",
      unlockPremiumLengths: "Desbloquear Longitudes de Historia Premium",
      upgradeForPremiumLengthsDescription: "Actualiza al plan Premium para crear historias más largas y desarrollar tus narrativas con mayor detalle.",
      longStoriesFeature: "Crea historias sin restricciones de longitud",
      avatarGenerator: {
        upgradeRequired: "Actualización Requerida",
        upgradeDescription: "Actualiza tu cuenta para generar avatares de personajes.",
        premiumFeature: "Genera avatares de personajes personalizados con una suscripción premium",
        upgradeNow: "Actualizar Ahora",
        upgradeTooltip: "Actualiza para generar avatares de personajes"
      },
      planComparison: {
        chooseYourPlan: "Elija el plan que mejor se adapte a sus necesidades",
        price: "Precio",
        features: "Características",
        talecraftBasic: "TaleCraft Básico",
        talecraftPremium: "TaleCraft Premium",
        savePercentage: "Ahorre 17%",
        currentPlanLabel: "Plan Actual:",
        processing: "Procesando...",
        downgradeToBasic: "Bajar a TaleCraft Básico",
        downgradeToFree: "Bajar a Plan Gratuito",
        upgradeToBasic: "Actualizar a TaleCraft Básico",
        upgradeToPremium: "Actualizar a TaleCraft Premium",
        downgradingTo: "Bajando a",
        effectiveOn: "Vigente a partir de",
        nextBillingDate: "Fecha de Próxima Facturación",
        featureItems: {
          dailyStoryLimit: "Límite Diario de Historias",
          aiStoryGeneration: "Generación de historias con IA",
          customResponses: "Respuestas personalizadas",
          aiTitleSuggestion: "Sugerencia de títulos con IA",
          customStorySelection: "Selección de historias personalizadas",
          publicSharing: "Compartir públicamente",
          characterManagement: "Gestión de personajes",
          aiProviderSelection: "Selección de proveedor de IA",
          statsAndBadges: "Estadísticas y Rangos/Insignias",
          badgeRewards: "Recompensas de insignias",
          naturalStoryLength: "Longitud natural de la historia",
          sequelsAndExtract: "Secuelas y extracción de personajes",
          characterAvatar: "Avatar de personaje",
          earlyAccessFeatures: "Funciones de acceso anticipado"
        },
        limits: {
          perDay: "/día",
          unlimited: "Ilimitado"
        }
      }
    },
    profile: {
      displayName: {
        label: "Nombre Visible",
        placeholder: "Ingrese su nombre visible",
        updateButton: "Actualizar Nombre",
        helpText: "Elija un nombre visible único para su perfil"
      },
      inviteFriends: {
        label: "Invitar Amigos",
        button: "Invitar Amigos",
        dialogTitle: "Compartir Invitación",
        dialogDescription: "Invita a tus amigos a unirse a tu viaje narrativo. Comparte tu enlace de invitación único o usa las redes sociales.",
        copySuccess: {
          title: "¡Enlace copiado!",
          description: "El enlace de referencia ha sido copiado a tu portapapeles."
        },
        copyFailure: {
          title: "Error al copiar",
          description: "Por favor, intenta copiar el enlace manualmente."
        },
        shareMessage: "¡Únete a nuestra aventura narrativa! Crea y comparte historias increíbles juntos.",
        socialPlatforms: {
          facebook: "Facebook",
          X: "X",
          linkedin: "LinkedIn",
        }
      },
      upgradeDialog: {
        title: "Actualización Requerida",
        aiProviderDescription: "Actualiza para seleccionar un proveedor de IA.",
        unlockProviderSelection: "Desbloquea la selección de proveedor de IA con una suscripción"
      }
    },
    issues: {
      title: "Reportar un problema",
      description: "¿Encontraste un error o tienes una sugerencia? ¡Háznoslo saber!",
      submitSuccess: "Problema reportado",
      submitSuccessDesc: "Gracias por tus comentarios. Investigaremos el problema.",
      submitError: "Envío fallido",
      submitErrorDesc: "Hubo un problema al reportar tu problema. Por favor, inténtalo de nuevo más tarde.",
      form: {
        titleLabel: "Título",
        titlePlaceholder: "Breve descripción del problema",
        descriptionLabel: "Descripción",
        descriptionPlaceholder: "Por favor, proporciona detalles sobre el problema...",
        priorityLabel: "Prioridad",
        priorityPlaceholder: "Seleccionar prioridad",
        priorityLow: "Baja",
        priorityMedium: "Media",
        priorityHigh: "Alta",
        priorityDescription: "Selecciona la urgencia de este problema para ayudarnos a priorizarlo adecuadamente.",
        submit: "Enviar reporte",
        submitting: "Enviando...",
        imagesLabel: "Adjuntar Imágenes",
        typeLabel: "Tipo de problema",
        typePlaceholder: "Seleccionar tipo de problema",
        typeBug: "Error",
        typeRequest: "Solicitud",
        typeDescription: "Selecciona el tipo de problema que estás reportando",
      },
      imageUpload: {
        dragDrop: "Arrastra y suelta imágenes aquí",
        dropHere: "Suelta imágenes aquí...",
        clickToSelect: "o haz clic para seleccionar archivos",
        maxSize: "Máx 5MB por archivo",
        maxNumber: "Máx 5 imágenes",
        attachedImages: "Imágenes Adjuntas",
        invalidFiles: "Algunos archivos no fueron aceptados",
        sizeTypeLimit: "Los archivos deben ser imágenes de menos de 5MB",
        tooManyImages: "Demasiadas imágenes",
        limitReached: "Solo puedes adjuntar hasta 5 imágenes",
        pasteSupported: "Pegado de imágenes soportado",
        pasteSuccess: "Imagen pegada",
        pasteSuccessDesc: "Imagen del portapapeles ha sido adjuntada",
        pasteFailed: "Error al pegar imagen",
        pasteFailedDesc: "Error al procesar el contenido del portapapeles",
        processing: "Procesando imagen...",
      },
    },
  }
};
